import React, { memo } from "react";
import { Description } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { GlobalInvoicesInputs } from "./GlobalInvoicesInputs";
import { FormGlobalInvoice } from "./FormGlobalInvoiceEdit";
import { GlobalBox } from "components/Box/GlobalBox";
import { useGlobalInvoicesInit } from "./hooks";

function GlobalInvoices() {
  useGlobalInvoicesInit();

  return (
    <GlobalBox
      title="Facturación Global"
      icon={<Description />}
      style={{
        minHeight: "80vh",
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <GlobalInvoicesInputs />
        </Grid>
        <Grid item xs={12}>
          <FormGlobalInvoice />
        </Grid>
      </Grid>
    </GlobalBox>
  );
}

export default memo(GlobalInvoices);
